import React, { useEffect, useState } from "react";
import {
  S1Prepare,
  S2WeightBeans,
  S3ChooseProfile,
  S4StartBrewing,
  S5Brewing,
} from "./steps";
import { useXBloom } from "./xbloom/useXBloom";

import "./button.css";
import "./Carousel.css";
import { Command } from "./xbloom/communicationDefinitions";
export const Carousel: React.FC = () => {
  const {
    connect,
    isConnected,
    machineState,
    loadProfile,
    start,
    command,
    stop,
  } = useXBloom();

  const [currentIndex, setCurrentIndex] = useState(0);
  const [waitingForAck, setWaitingForAck] = useState(false);

  const isFirstStep = currentIndex === 0;

  const handleNext = () => {
    setCurrentIndex((prev) => prev + 1);
  };

  const handleBack = () => {
    if (!isFirstStep) {
      setCurrentIndex((prev) => prev - 1);
    }
  };

  const handleStartOver = () => {
    setCurrentIndex(0);
  };

  useEffect(() => {
    if (waitingForAck && machineState?.profileLoaded) {
      setWaitingForAck(false);
      handleNext();
    }
  }, [waitingForAck, machineState]);

  const supportsBluetooth = !!navigator.bluetooth;
  if (!supportsBluetooth) {
    return (
      <div className="carousel header">
        <h1>
          Web Bluetooth is not supported on your device. This is required to
          connect to the xBloom
        </h1>
        <h1>Use Chrome and ensure you are using https if you are on mobile</h1>
      </div>
    );
  }
  if (!isConnected) {
    return (
      <div className="carousel">
        <div className="header">
          <h1>XBloom: Coffee Selfservice</h1>
          <div className="connectControls">
            <button className="button buttonFail" onClick={connect}>
              xBloom Disconnected! Click me to Connect
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="carousel">
      <div className="header">
        <h1>XBloom: Coffee Selfservice</h1>
        <div className="connectControls">
          {isConnected ? (
            <button className="button buttonSuccess" onClick={connect}>
              xBloom Connected! Click me to (Re)Connect
            </button>
          ) : (
            <button className="button buttonFail" onClick={connect}>
              xBloom Disconnected! Click me to Connect
            </button>
          )}
        </div>
      </div>
      <div
        className="slides"
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        <div className="slide">
          <S1Prepare />
        </div>{" "}
        <div className="slide">
          <S2WeightBeans
            weight={machineState?.weight}
            tare={() => command(Command.CMD_DISPLAY_ENTER_SCALE)}
          />
        </div>{" "}
        <div className="slide">
          <S3ChooseProfile
            profiles={["Standart V60 92° 50g/100g/100g in 4:10 minutes"]}
            onSelect={() => {
              loadProfile();
              setWaitingForAck(true);
              setTimeout(() => {
                setWaitingForAck(false);
                handleNext();
              }, 5000);
            }}
          />{" "}
        </div>{" "}
        <div className="slide">
          <S4StartBrewing
            onClick={() => {
              start();
              setWaitingForAck(true);
            }}
          />
          ,
        </div>
        <div className="slide">
          <S5Brewing onClick={stop} />,
        </div>
      </div>

      <div className="controls">
        <button
          className={`button ${isFirstStep ? "buttonDisabled" : ""}`}
          onClick={handleBack}
          disabled={isFirstStep}
        >
          Back
        </button>
        <button
          className={`button ${currentIndex > 2 ? "buttonDisabled" : ""}`}
          disabled={currentIndex >= 2}
          onClick={handleNext}
        >
          Next
        </button>
        <button className="button" onClick={handleStartOver}>
          Start Over
        </button>
      </div>
    </div>
  );
};
